import React from 'react';
import './DataPrivacy.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShieldAlt, faLock, faUserShield } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';

const DataPrivacy: React.FC = () => {
  const { t } = useTranslation();
  const icons = [faShieldAlt, faLock, faUserShield];
  const features = t('dataPrivacy.features', { returnObjects: true }) as {
    title: string;
    description: string;
  }[];

  return (
    <section className="data-privacy">
      <div className="container">
        <div className="data-privacy-content">
          <div className="data-privacy-header">
            <h2 >{t('dataPrivacy.title')}</h2>
            <p>{t('dataPrivacy.subtitle')}</p>
          </div>
          <div className="data-privacy-features">
            {features.map((feature, index) => (
              <div key={index} className="feature-card">
                <div className="feature-icon">
                  <FontAwesomeIcon icon={icons[index]} />
                </div>
                <h3>{feature.title}</h3>
                <p>{feature.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default DataPrivacy;
